export const useAuth = () => ({
    /**
     * Make sure you have a valid token for the auth api to work correctly.
     * You can load a non-embedded page in manage app which will auto-refresh the token.
     */
    token: async () => localStorage.getItem("migrations-auth-token") || "",
    idToken: async () => localStorage.getItem("migrations-auth-id-token") || "",
  });
  